/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {  useRef, useState,useCallback,useEffect } from 'react';
import { DataGrid, EditModal} from "../../../common";
import { useTranslation } from 'react-i18next';
import { APIEndpoint} from "../../../utils/axios";
import deleteIcon from '../../../assets/icons/deleteRole.svg';
import editIcon from "../../../assets/edit.svg";
import {formatDateByTimezone,storageUtil} from '../../../utils/commonFunctions';
import {parseJwtToken} from '../../../utils/commonFunctions.js';
import moment from "moment";
import searchIcon from '../../../assets/icons/search.svg';
import CustomSelect from '../../../common/CustomSelect';


const assignMentType=[{key:0,label:'Select Assignment Type',value:''},{key:1,label:'Role',value:'role'},{key:2,label:'Permission',value:'permission'}]
;
  const AddRolesFields = [
    {label: 'User', attribute: 'subject', type: 'selectSearch2', disabled: false, required: true },
    {label: 'Assignment Type', attribute: 'assignmentType', type: 'select',options:assignMentType,required:true, disabled: false },
  ];

  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    limit: 50,
    page: 1,
  
  };
  export const ManageUserRolesAndPermissionPage = () => {
  const tableRef = useRef();
  const modalResource = useRef();
   const handleBeforeUnloadRef = useRef(null);
  const apiResetRef = useRef(true);
  const { t,ready } = useTranslation();
  const [searchKey, setSearchKey] = useState('');
  const [searchFilterObj,setSearchFilterObj]=useState({});
  const [editFieldsPerm,setEdiFieldsPerm]=useState([]);
  const [state,setState] = useState({resetDataSource:false,disabled:false,dateSel:null,userSelected:null,actionSelected:null,resourceSelected:null,roleSelected:null,assignType:null,filtersSelected:false})
  const [rolesArr,setRolesArr]=useState([]);
  const [modalFormData, setModalFormData] = useState({});
  const [useContext, setUserContext] = useState({});
  const [searchFields, setSearchFields] = useState({});
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [userResources, setUserResources] = useState([]);
  const [userActions, setUserActions] = useState([]);
  const [modalTitle, setModalTitle] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [isDropDownOpen,setIsDropdownOpen]=useState(false);
  const [ModalContHeight,setModalContHeight]=useState({height:'auto'})
  const [modalCustomButtons, setModalCustomButtons] = useState([]);
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  

  const stateRef = useRef(state);

  async function getEmployessAll() {
    setLoadingUsers(true);
    try {
      const initialRes = await fetchEmployees(1, 1);
      if (initialRes?.count && Array.isArray(initialRes.items) && initialRes.items.length) {
        const fullRes = await fetchEmployees(1, initialRes.count);
        if (fullRes?.items?.length) {
          setEmployees((prev) => [...prev,...fullRes.items.map((item, index) => ({key: item.id || index, label: `${item.employeeCode} - ${item.name}`,value: item.employeeCode}))]);
        }
      }
    } catch (error) {
      console.error("Failed to fetch employees:", error);
    } finally {
      setLoadingUsers(false);
    }
  }

  
useEffect(() => {
  getUserPolicies();
  if (!employees.length) {
    getEmployessAll();
  }
     const handleBeforeUnload = () => {
      storageUtil.clear('cursor', 'session');
    };

    handleBeforeUnloadRef.current = handleBeforeUnload;

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
     if (handleBeforeUnloadRef.current) {
      window.removeEventListener('beforeunload', handleBeforeUnloadRef.current);
    }
    };
}, []);

 useEffect(() => {
  if(isDropDownOpen){
    setModalContHeight({height:'55vh'})
  }else{
    setModalContHeight({height:'auto'})
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isDropDownOpen]);
useEffect(() => {
  if(state.filtersSelected){
   apiResetRef.current=false;
    fetchUserRolesPermission(1,50,null,searchFilterObj,true);
  }
}, [searchFilterObj]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      storageUtil.clear('cursor', 'session');
    }, 300); 
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchKey]);

useEffect(() => {
stateRef.current = state
if (state && state.filtersSelected) {
  setSearchFields(prev => ({
    ...prev,
    subject: state.userSelected ? state.userSelected.value : state.userSelected,
    assignmentType: state.assignType ? state.assignType.value : state.assignType,
    code: 
      (state.roleSelected && state.roleSelected.value) ||
      (state.actionSelected && state.actionSelected.value) ||
      (state.resourceSelected && state.resourceSelected.value),
    createdOn: state.dateSel 
      ? formatDateByTimezone(new Date(state.dateSel), false).split("T")[0]
      : state.dateSel
  }));
}

}, [state])

useEffect(() => {
  if(modalFormStatusObj && modalFormStatusObj?.text && modalFormStatusObj?.text.length && !state?.selected){
     setState((_)=>({..._,resetDataSource:!_.resetDataSource,filtersSelected:false}))
  }
  }, [modalFormStatusObj])
    

  useEffect(() => {
    storageUtil.clear('cursor','session');
    setSearchFilterObj(Object.entries(searchFields).reduce((acc,[key,value],index)=>{
      if(value!==null){
        acc[key]=value
      }
      return acc;
    },{}))
    }, [searchFields])
 
useEffect(() => {
  if (modalFormData?.resource && Array.isArray(useContext.resources) && useContext.resources.length) {
    const selectedResource = useContext.resources.find(item => item.code === modalFormData.resource);
    if( modalResource.current !== modalFormData?.resource){
      setModalFormStatusObj({ notification: selectedResource?.description });
    const timeout = setTimeout(() => {
     modalResource.current = modalFormData?.resource;
      setModalFormStatusObj({ text: '' });
    }, 2700);

    return () => clearTimeout(timeout);
    }

  }
}, [modalFormData, useContext.resources]);

function onAction(e,type,data){
    if(type==='editUser' ||type==='AddItem'){
        setModalTitle(`${type==='editUser'?'Edit':'Add'} User Access`);
        let editFieldsAdd=[];
        if(data && data?.assignmentType!=='role'){
         const {permissions}=data||{};
  const {resource,action,effect}=permissions[0]||{};

  data=data.permissions.length?{id:data._id,subject:data.subject,assignmentType:data.assignmentType,resource:resource.code,action:action.code,effect:effect==='allow'?true:false}:data;

editFieldsAdd.push( { label: 'Resource', attribute: 'resource', type: 'selectSearch2', options: userResources,disabled:false, required: true },
  { label: 'Action', attribute: 'action', type: 'selectSearch2', options: userActions,disabled: false, required: true },
  { label: 'Allow/Deny', attribute: 'permission', type: 'checkbox',disabled: false })
        }
        else if(data && data?.assignmentType==='role'){
          const {roles}=data;
  data=roles.length?{id:data._id,subject:data.subject,assignmentType:data.assignmentType,roles:roles}:data;

 editFieldsAdd.push( {
  label: 'Roles',
  attribute: 'roles',
  type: 'rcSelectAll',
  data:rolesArr.filter(function(option) {
    return  roles && roles.length &&  roles.find(sc=>sc?.name === option?.label)
    }),
  disabled: false,
  options: rolesArr,
  required: true
})
         }

        type==='editUser'?setState((_)=>({..._,selected:{...data,type:type}})):setState((_)=>({..._,selected:{type:type}}));

       const userUpdate = type!=='editUser'?AddRolesFields.map((item,index)=>{
          if(item.attribute==='subject'){
            return {...item,options:employees}
          }
          else return item;
        }):AddRolesFields.map((item,index)=>{
          if(item.attribute==='subject'){
            return {...item,options:employees,initialValue:data?.subject||null}
          }
          if(item.attribute==='assignmentType'){
            return {...item,disabled:true}
          }
          else return item;
        });

        !editFieldsAdd.length? setEdiFieldsPerm(userUpdate):setEdiFieldsPerm([...userUpdate,...editFieldsAdd]);
    }
    else{
      const assnType=data?.assignmentType.charAt(0).toUpperCase()+data?.assignmentType.slice(1);
      setModalTitle(`Remove ${assnType} - ${data.subject}`);
     let updatedEditFields = [
        {
            label: `You are about to ${type} ${assnType} of ${data.subject}. Are you sure you want to continue?`,
            attribute: 'alertMessage', type: 'alertMessage'
        }
    ];
    setModalCustomButtons([{label:'Confirm',attribute:'button',type:"button",disabled:false,className:'submit-button',action:onDeleteUserRolesAndPerm}])
       setEdiFieldsPerm(updatedEditFields);
       stateRef.current = data;
       setState( (_prev) => {
        return { ..._prev,selected:{...data,type:type}}
         });
    }
}

async function onDeleteUserRolesAndPerm(){
  const { subject, assignmentType, _id } = stateRef.current.selected;
  const submitDisabled=document.getElementsByClassName('submit-button')[0];
    let body={}
    if (assignmentType === 'role') {
      const {selected} = stateRef.current;
      const roles = selected.roles;
      const filteredRoles = useContext.roles.filter(
        rl => roles.some(mrl => (mrl.name ?? mrl.label) === rl.name)
      );

      body = {
        id:_id,
        subject:subject,
        assignmentType,
        roles: filteredRoles,
      };
    } else {
      const {resource,action,effect} = stateRef.current.selected.permissions[0]||{};

      body = {
        id:_id,
        subject:subject,
        assignmentType,
        resource: useContext.resources.find(rl => rl.code === resource.code),
        action: useContext.actions.find(rl => rl.code === action.code),
        effect: effect,
      };
    }

 const storedCreds = localStorage.getItem('login_credentials');
    if (!storedCreds) return;

    let loginCred;
    try {
      loginCred = JSON.parse(storedCreds);
    } catch (parseError) {
      console.error('Failed to parse stored credentials:', parseError);
      return;
    }

    const { data, headers } = loginCred || {};
    const tokenResp = await parseJwtToken(data);
    if (!tokenResp?.userId || !data?.token || !headers?.['x-csrf-token']) return;
    const requestHeaders = {
      'Accept': 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      'user_id': tokenResp.userId,
      'X-Bearer-Token': data.token,
      'X-Csrf-Token': headers['x-csrf-token']
    };

try{
  if(submitDisabled){
    submitDisabled.setAttribute('disabled', 'true');
  }
    const response = await fetch(APIEndpoint.getFullPath('authz/user/rolePermissions'), {
      method: 'DELETE',
      body: JSON.stringify(body),
      headers: requestHeaders
    });

    if (response.ok) {
      const resData = await response.json();
      setModalFormStatusObj({ text: resData?.message || 'Successfully Deleted' });
    } else {
      const errorMsg = await response.json();
      setModalFormStatusObj({ error: `${errorMsg?.message??'Failed to Delete'}` });
    }
  }
  catch (err) {
    let parsedError;
    try {
      parsedError = JSON.parse(err?.message);
    } catch (parseError) {
      if(submitDisabled){
        submitDisabled.removeAttribute('disabled');
      }
      console.error('Failed to parse error message:', parseError);
      parsedError = { data: { message: 'An unexpected error occurred' } };
    }
    setModalFormStatusObj({ error: parsedError?.data?.message || 'Failed to Delete Role' });
  } finally {
    handleReset(submitDisabled);
  }

}

  const valueGetter=(params)=>{
    const { colDef, data } = params;
    if (!data) {
      return '';
    }

    const {permissions,audit,roles,assignmentType}=data||{};

switch (`${data.assignmentType} ${colDef.field}`) {
  case "permission resources":
    return (
          <><div className='flexRow justifyContentSpaceBetween' style={{width:'100%',maxWidth:'410px',overflow:'auto'}}>
          <div className='sector-container justifyContentFlexStart alignItemsCenter' style={{maxWidth:'310px',width:'250px'}}>{permissions && permissions.length > 0 ? permissions.map((key, index) => (
        <span key={index} className={!index?"sector-label margSecotInit":"sector-label"}>{key.resource.name}</span>
          )) :null}</div>
       </div>
          </>
    );
    case  "permission actions":
        return (
          <><div className='flexRow justifyContentSpaceBetween' style={{width:'100%',maxWidth:'410px',overflow:'auto'}}>
          <div className='sector-container justifyContentFlexStart alignItemsCenter' style={{maxWidth:'310px',width:'250px'}}>{permissions && permissions.length > 0 ? permissions.map((key, index) => (
        <span key={index} >{key.action.name}</span>
          )) :null}</div>
       </div>
          </>
        );

        case  "permission effect":
        return (
          <><div className='flexRow justifyContentSpaceBetween' style={{width:'100%',maxWidth:'355px',overflow:'auto'}}>
          <div className='sector-container justifyContentFlexStart alignItemsCenter'  style={{maxWidth:'310px',width:'250px'}}>{permissions && permissions.length > 0 ? permissions.map((key, index) => (
          <span key={index}>{key.effect === 'deny'? 'Denied': key.effect.charAt(0).toUpperCase() + key.effect.slice(1) + 'ed'}</span>
          )) :null}</div>
       </div>
          </>
        );
        case  "permission assignmentType":
          return (
            <><div className='flexRow justifyContentSpaceBetween' style={{width:'100%',maxWidth:'355px',overflow:'auto'}}>
            <div className='sector-container justifyContentFlexStart alignItemsCenter'  style={{maxWidth:'310px',width:'250px'}}>
            <span >{assignmentType.charAt(0).toUpperCase()+assignmentType.slice(1)}</span>
        </div>
         </div>
            </>
          );
          case  "permission createdAt":
            return (
              <><div className='flexRow justifyContentSpaceBetween' style={{width:'100%',maxWidth:'355px',overflow:'auto'}}>
              <div className='sector-container justifyContentFlexStart alignItemsCenter'  style={{maxWidth:'310px',width:'250px'}}>
              <span >{audit.createdOn?moment(formatDateByTimezone(audit.createdOn)).format("DD-MM-YYYY"):""}</span>
          </div>
           </div>
              </>
            );
            case  "role createdAt":
              return (
                <><div className='flexRow justifyContentSpaceBetween' style={{width:'100%',maxWidth:'355px',overflow:'auto'}}>
                <div className='sector-container justifyContentFlexStart alignItemsCenter'  style={{maxWidth:'310px',width:'250px'}}>
                <span >{audit.createdOn?moment(formatDateByTimezone(audit.createdOn)).format("DD-MM-YYYY"):""}</span>
            </div>
             </div>
                </>
              );
          case  "role assignmentType":
            return (
              <><div className='flexRow justifyContentSpaceBetween' style={{width:'100%',maxWidth:'365px',overflow:'auto'}}>
              <div className='sector-container justifyContentFlexStart alignItemsCenter'  style={{maxWidth:'310px',width:'250px'}}>
              <span>{assignmentType.charAt(0).toUpperCase()+assignmentType.slice(1)}</span>
             </div>
           </div>
              </>
            );

        case "role role":
    return (
          <><div className='flexRow justifyContentSpaceBetween' style={{width:'100%',maxWidth:'355px',overflow:'auto'}}>
          <div className='sector-container justifyContentFlexStart alignItemsCenter'  style={{maxWidth:'310px',width:'250px'}}>{roles && roles.length > 0 ? roles.map((key, index) => (
        <span key={index} className={!index?"sector-label-minGrid margSecotInit":"sector-label-minGrid"}>{key.name}</span>
          )) :null}</div>
       </div>
          </>
    );

  default:
    return (
      <>
      </>
);

}

  }

  function actionUsersUpdate(props){
      return (
        props.data?
        <>
        <div className='flexRow margTop8'>
      { true?    <div className='icon-aircraft-container'>
          <img className='aircraft-actions' alt='edit' onClick={(e) => onAction(null,'editUser',props.data)} src={editIcon}/>
          <span className="tooltip-action">Edit</span>
          </div>:<></>}
          {true?<div className='icon-aircraft-container'>
          <img className='aircraft-actions' alt='delete' onClick={(e) => onAction(null,'remove',props.data)} src={deleteIcon}/>
          <span className="tooltip-action">Delete</span>
          </div>:<></>}
        </div>

        </> : <></>
      );
    }


  const Columns = [
    { field: 'userDetails.name', headerName: 'User',resizable:true,minWidth:130,width:140,suppressSizeToFit:true,flex:1 },
    { field: 'assignmentType', headerName: 'Assignment Type',resizable:true, cellRendererFramework: valueGetter, suppressSizeToFit:true,flex:1,minWidth:90,width:100 },
    { field: 'role',headerName: 'Roles',cellRendererFramework: valueGetter, flex:1,suppressSizeToFit:true, minWidth: 360,resizable:true},
    { field: 'resources',headerName: 'Resource',cellRendererFramework: valueGetter, flex:1,suppressSizeToFit:true, minWidth: 220,resizable:true},
    { field: 'actions', headerName: 'Action',minWidth:120, cellRendererFramework: valueGetter,suppressSizeToFit:true,flex:2},
    { field: '', headerName: 'Actions',pinned:'right',minWidth:120,width:130, cellRendererFramework: actionUsersUpdate,suppressSizeToFit:true,flex:1},
];
async function fetchEmployees(page=1, perPage=1,searchKey=''){
  filterData.page = page;
  filterData.limit = perPage;
  filterData.searchParam = searchKey;
  try {
    const res=await APIEndpoint.post('employees/process',filterData);
    return res;
  } catch (error) {
    console.log("Error")
  }
}

  async function getUserPolicies(){
    try {
      const[res1,res2,res3]= await Promise.all([
         APIEndpoint.get('authz/resources'),
         APIEndpoint.get('authz/actions'),
         APIEndpoint.get('authz/roles'),
       ]);
     if( res1 && res1.items && res2 && res2.items && res3 && res3.items){
      setUserContext({resources:res1.items?.map(({_id,...rest})=>({id:_id,...rest})),actions:res2.items?.map(({_id,...rest})=>({id:_id,...rest})),roles:res3?.items})
       setUserResources(()=>{
         return res1.items?.map((item,index)=>({key:index,label:item.name,value:item.code,desc:item.description}))
       });
       setUserActions(()=>{
         return res2.items?.map((item,index)=>({key:index,label:item.name,value:item.code}))
       });
       setRolesArr(()=>{
        return res3.items?.map((item,index)=>({key:index,label:item.name,value:item.code}))
      });

     }
     } catch (error) {

     }
 }

const fetchUserRolesPermission = useCallback(async function (iPageNo = 1,iPageLimit = 50,searchText = null,fObj = null,searchMode=false) {
  
  const filterDataNew = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters:{},
    limit: iPageLimit,
    page:iPageNo,
   };
    filterDataNew.searchKey = searchKey;
    filterDataNew.filters = fObj??searchFilterObj;
    const sessionCursor = storageUtil.get('cursor','session');
    if(!searchMode && sessionCursor){
      filterDataNew.cursor = sessionCursor;
    }
  try {
    const res = await APIEndpoint.post('authz/user/rolePermissions/list', filterDataNew);
    const items = Array.isArray(res.items) ? res.items.filter(Boolean) : [];
    res.items = items;
    const lastItem = items[items.length - 1];
    if (lastItem?._id && !searchMode) {
       storageUtil.set('cursor', btoa(lastItem._id), 'session');
    } 
    return res;

  } catch (error) {
    console.error("Error fetching user roles/permissions:", error);
  
  } finally {
    if (!apiResetRef.current) {
      setState((_) => ({
        ..._,
        resetDataSource: !_.resetDataSource,
        filtersSelected: false
      }));
      apiResetRef.current = true;
    }
  }
}, [searchFilterObj,searchKey]);




  const onSearch = (e) => {
    setSearchKey(e.target.value);
  };

  function onFieldChangeHandler(e, update) {
    if (!update||!e) return;
    const { name, value,checked } = e.target;
    let newUpdates = modalFormData ? { ...modalFormData } : {}
    if(state.selected && state.selected.type!=='editUser'){
       if(name==='permission'){
         newUpdates['effect'] = checked;
         setModalFormData((_)=>( {...newUpdates }) );
      }
      else{
        newUpdates[name] = value;
    setModalFormData((_)=>( {...newUpdates }) );
    setEdiFieldsPerm(prev => {
      const isRole = update.assignmentType === 'role';
      const isPermission = update.assignmentType === 'permission';
      let newFields = [...prev];

      if (isRole) {
        newFields = newFields.filter(fld =>
          fld.attribute !== 'resource' &&
          fld.attribute !== 'action' &&
          fld.attribute !== 'permission'
        );

        const hasRoles = newFields.some(fld => fld.attribute === 'roles');

        if (!hasRoles) {
          newFields.push({
            label: 'Roles',
            attribute: 'roles',
            type: 'rcSelectAll',
            disabled: false,
            options: rolesArr,
            required: true
          });
        }
      }

      if (isPermission) {
        newFields = newFields.filter(fld => fld.attribute !== 'roles');

        const hasPermissionFields = newFields.some(fld => fld.attribute === 'resource');
        if (!hasPermissionFields) {
          newFields.push(
            { label: 'Resource', attribute: 'resource', type: 'selectSearch2', options: userResources, disabled: false, required: true },
            { label: 'Action', attribute: 'action', type: 'selectSearch2', options: userActions, disabled: false, required: true },
            { label: 'Allow/Deny', attribute: 'permission', type: 'checkbox', disabled: false }
          );
        }
      }

      return newFields;
    });
      }

    }else{
      if(name==='permission'){
        newUpdates['effect'] = checked;
        setEdiFieldsPerm(prev=>{
          return prev.map((item,index)=>{
            if(item.attribute==='permission'){
              return{...item,checked:!item.checked}
          }
          return item
        }
        )
        })
      setModalFormData((_)=>( {...newUpdates }) );
        }
    }

  }
  function handleReset(attr=null){
     storageUtil.clear('cursor','session');
    setState(_=>({..._,resetDataSource:!_.resetDataSource}));
    setTimeout(() => {
      if(attr){
        attr.removeAttribute('disabled');
      }
    onClose();
    }, 2000);
  }


async function onSubmit(){
  setState(_=>({..._,disabled:true}));
  let body={}
  if(modalFormData && state.selected && state.selected.type!=='editUser'){
    if(modalFormData.assignmentType==='role'){
     body={...modalFormData,roles:useContext.roles.filter(rl=>modalFormData.roles.some(mrl=>mrl.label===rl.name))}
    }
    else{
      body={...modalFormData,resource:useContext.resources.filter(rl=>modalFormData.resource===rl.code)[0],action:useContext.actions.filter(rl=>modalFormData.action===rl.code)[0],effect:modalFormData.effect?'allow':'deny'}
    }

try {
  const res=await APIEndpoint.post('authz/user/rolePermissions',body)
 if(res){
  setModalFormStatusObj({text:res.message||"Success"});
  handleReset();
 }
} catch (error) {
  const errObj = JSON.parse(error?.message);
  setModalFormStatusObj({ error: errObj?.data.msg|| errObj?.data.message ||'Something went wrong. Please try again after some time.' });
setState(_=>({..._,disabled:false}));
}
  }
  else if(state.selected && state.selected.type==='editUser') {
    const { subject, assignmentType, id } = state.selected;
    if (assignmentType === 'role') {
      const roles = modalFormData?.roles?.length ? modalFormData.roles : state.selected.roles;
      const filteredRoles = useContext.roles.filter(
        rl => roles.some(mrl => (mrl.name ?? mrl.label) === rl.name)
      );

      body = {
        id,
        subject: modalFormData?.subject ?? subject,
        assignmentType,
        roles: filteredRoles,
      };
    } else {
      const {resource,action,effect} = state.selected||{};

      const resourceCode = modalFormData?.resource ?? resource;
      const actionCode = modalFormData?.action ?? action;
      const effectAct = modalFormData?.effect ?? effect;

      body = {
        id,
        assignmentType,
        subject: modalFormData?.subject ?? subject,
        resource: useContext.resources.find(rl => rl.code === resourceCode),
        action: useContext.actions.find(rl => rl.code === actionCode),
        effect: effectAct ? 'allow' : 'deny',
      };
    }

    try{
      const res=await APIEndpoint.put('authz/user/rolePermissions',body)
      if(res){
       setModalFormStatusObj({text:res?.message||"Success"});
       handleReset();
      }
    }
    catch (error) {
      const errObj = JSON.parse(error?.message);
      setModalFormStatusObj({ error: errObj?.data?.msg|| errObj?.data?.message ||'Something went wrong. Please try again after some time.' });
    setState(_=>({..._,disabled:false}));
    }
  }
  else{}
     storageUtil.clear('cursor','session');
}

function onRolesChange(upd){
  if(state.selected.type!=='editUser'){
    setModalFormData((prev) => ({
      ...prev,
      ...(prev.assignmentType && prev.assignmentType !== 'role'
        ? upd
        : {
            subject:!Array.isArray(upd) && Object.keys(upd).includes('subject')? upd.subject || null: prev.subject,
            roles: Array.isArray(upd) && upd.length ?upd: null
          })
    }));

  }
  else if(state.selected.type==='editUser' && state.selected.assignmentType && state.selected.assignmentType==='role'){
if(!Array.isArray(upd)&&Object.keys(upd).length &&Object.keys(upd).includes('subject')){
    setState(prev => ({
      ...prev,
      selected: {
        ...prev.selected,
        subject: upd.subject === undefined ? null : upd.subject?upd.subject : prev.selected.subject,
      }
    }));
  }
    setModalFormData((prev) => (
      Array.isArray( upd )
        ? { ...prev, roles: upd,assignMentType:'role' }: { ...prev,assignMentType:'role', roles: upd.roles??prev.roles,subject:upd.subject??null}
    ));
  }
  else if(state.selected.type==='editUser'&& state.selected.assignmentType && state.selected.assignmentType==='permission'){

        setState(prev => ({
          ...prev,
          selected: {
            ...prev.selected,
            subject: Object.keys(upd).includes('subject') && upd.subject === undefined ? null : upd.subject?upd.subject : prev.selected.subject,
            action: Object.keys(upd).includes('action') && upd.action === undefined ? null : upd.action?upd.action : prev.selected.action,
            resource:Object.keys(upd).includes('resource') &&  upd.resource === undefined ? null : upd.resource?upd.resource : prev.selected.resource,
          }
        }));

        setModalFormData(prev =>({...prev,...upd}));
      }

}

  function onClose(){
    setState(_=>({..._,selected:null,resetDataSource:modalFormStatusObj.text && modalFormStatusObj.text?.length?!_?.resetDataSource:_.resetDataSource,disabled:false,filtersSelected:false}))
    setModalFormStatusObj({text:""});
    setEdiFieldsPerm([]);
    setModalCustomButtons([]);
    setModalFormData({});
  }

function onAddItemHandler(e){
  onAction(e,'AddItem',null)
}

  return (
      <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      
      <>

      <div className='flexRow width100 margBot10 margTop8 justifyContentSpaceBetween'>
      <div className='flexRow justifyContentFlexStart alignItemscenter margBot10'>
        <div className='margRight10'>
      <CustomSelect
      options={employees}
      placeHolder="Search User"
      width={'13rem'}
      onChange={(val)=>setState((_)=>({..._,userSelected:val,filtersSelected:true}))}
      />
      </div>

      <div className='margRight10'>
          
          <CustomSelect
                      options={rolesArr}
                      placeHolder="Search Role"
                      width={'10rem'}
                      onChange={(val)=>setState((_)=>({..._,roleSelected:val,filtersSelected:true}))}
              
                    />
                          </div>    
                  

                      <CustomSelect
                      options={userResources}
                      placeHolder="Search Resource"
                      width={'11rem'}
                      onChange={(val)=>setState((_)=>({..._,resourceSelected:val,filtersSelected:true}))}
              
                    />
                
                   
      </div>


      <div className='width100Menu justifyContentFlexStart flexRow'>
      <div className="margLeft16 margBot10 underline">
      <span><img  className="icon-size" alt={t('filters.searchText')} src={searchIcon} /></span>
      <span><input className="search" onChange={onSearch} type="search" placeholder={t('filters.searchText')} value={searchKey}/></span>
      </div>
      </div>
      <div className="margLeft flexRow justifyContentFlexEnd alignItemsBaseline">
      <button disabled={loadingUsers} className="add-item-button" onClick={ onAddItemHandler }>
      {loadingUsers?'Please wait...': '+ User Access'}
      </button>
      </div>
      </div>


      <DataGrid
      ref={tableRef}
      className='full-flex'
      columns={[...Columns]}
      initialPageLimit={50}
      showDefaultFilters={false}
      rowSelection="multiple"
      searchKey={searchKey}
      columnResize={true}
      resetDataSource={state.resetDataSource}
      getRows={fetchUserRolesPermission} />
      </>
      

      {
      Boolean(state?.selected) && state.selected.type ? (
      <EditModal
      mainContentCenter
      key={state.selected.type}
      title={ modalTitle }
      onClose={onClose}
      modalFormStatusObj={modalFormStatusObj}
      onSubmit={onSubmit}
      showFieldsInColumn={true}
      customContentHeight={ModalContHeight}
      setIsDropdownOpen={setIsDropdownOpen}
      buttonLabel={'Save'}
      disabled={state.disabled}
      modalCustomButtons={modalCustomButtons}
      onChange={ (e,updated) => {
      setModalFormStatusObj({text:""});
      onFieldChangeHandler(e,updated);
      if(!e && updated){
        onRolesChange(updated)
      }
      }
      }
      fields={editFieldsPerm.map( (elt) => {
      if(state.selected.type==='editUser' ){
        return { ...elt, ...(elt.type==='checkbox'?{checked:state.selected[elt.attribute]??elt.checked??state.selected['effect']}:{value:state.selected[elt.attribute]??""})}
      }else{
        return { ...elt, initialValue: state.selected[elt.attribute]??"" }
      }
      })
      }
      />
      )
      : null
      }
      {
      !ready &&<div className='overlay_hide sub'></div>
      }
      </div>
  )
}
